import { type Alias } from '#shared/api/schema';
import { CONSTRUCTOR_LEGAL_PAGES } from '../constants';

export const isConstructorPageLegal = (alias: Alias) => alias && CONSTRUCTOR_LEGAL_PAGES.includes(alias);
